module.exports = __webpack_public_path__ + "static/media/coupon-icon-active.9298b76c.svg";